// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "05f6971a" + "." + "ad64505f44e190d2" + ".js";
};